export class ImageCarousel {
	private imageCarousels: Element[] = [];

	private nextImage = function(imageCarousel: Element) {
		const images = imageCarousel.querySelectorAll("label + image, label + figure");
		
	};

	private previousImage = function(imageCarousel: Element) {

	};

	init(): void {
		console.debug("Initializing Image Carousels...");
		this.imageCarousels = [...document.querySelectorAll(".image-carousel")];

		this.imageCarousels.forEach(imageCarousel => {
			const previousButtons = imageCarousel.querySelectorAll(".previous");
			const nextButtons = imageCarousel.querySelectorAll(".next");
			imageCarousel.classList.add("js-scroll");

			// ToDo: Might need to have this re-organize the html structure so there is a way to easily shift the images around.

			previousButtons.forEach(previousButton => previousButton.addEventListener("click", () => this.previousImage(imageCarousel), false));
			nextButtons.forEach(nextButton => nextButton.addEventListener("click", () => this.nextImage(imageCarousel), false));
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const imageCarousel = new ImageCarousel();

	imageCarousel.init();
});